<template>
  <section
    v-editable="blok"
    class="flex flex-col gap-8 md:grid md:grid-flow-col"
    :class="[
      marginClasses,
      {
        'grid-fix-size--small-right': blok.size_columns === 'smallRight',
        'grid-fix-size--small-left': blok.size_columns === 'smallLeft',
      },
      { '!gap-0': blok.removeMargin_sides },
    ]"
  >
    <!-- Image is not allowed as a component so we have to rename it here -->
    <component
      :is="['Image'].includes(column.component) ? 'CmsImage' : column.component"
      v-for="(column, index) in blok.columns"
      :key="column._uid"
      class="grid-fix-size__column"
      :blok="column"
      :sibling-index="index"
    />
  </section>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import useStoryblokMargins from '~/cms/storyblok/composables/useStoryblokMargins'
import type { SbGridFixSize } from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  blok: {
    type: Object as PropType<SbGridFixSize>,
    required: true,
  },
})

const { marginClasses } = useStoryblokMargins(props.blok)
</script>
<style lang="postcss" scoped>
/* Use fr so gap is included in track sizing; 70%+30%+gap would overflow the container */
.grid-fix-size--small-right {
  grid-auto-columns: 7fr 3fr;
}
.grid-fix-size--small-left {
  grid-auto-columns: 3fr 7fr;
}
.grid-fix-size__column {
  min-width: 0;
}
</style>
